import { render, staticRenderFns } from "./VCkeditor.vue?vue&type=template&id=1d14c89e&"
import script from "./VCkeditor.vue?vue&type=script&lang=js&"
export * from "./VCkeditor.vue?vue&type=script&lang=js&"
import style0 from "./VCkeditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VMessages } from 'vuetify/lib/components/VMessages';
installComponents(component, {VCard,VLabel,VMessages})
